'use client';

import type { FC } from 'react';
import { CommonSelect, type SelectOption } from '@/app/components/shared/CommonSelect';

export const OFFLINE_AVATAR_RESOLUTION_OPTIONS = ['720p'] as const;

export type OfflineAvatarResolution = (typeof OFFLINE_AVATAR_RESOLUTION_OPTIONS)[number];

const RESOLUTION_OPTIONS: SelectOption[] = OFFLINE_AVATAR_RESOLUTION_OPTIONS.map((option) => ({
  value: option,
  label: option.toUpperCase(),
}));

interface OfflineAvatarCombinedSettingProps {
  resolution: string;
  onChange: (resolution: string) => void;
}

export const OfflineAvatarCombinedSetting: FC<OfflineAvatarCombinedSettingProps> = ({ resolution, onChange }) => {
  return (
    <CommonSelect
      value={resolution.toLowerCase()}
      options={RESOLUTION_OPTIONS}
      onValueChange={onChange}
      className="h-10 w-24 shrink-0 rounded-10 border border-transparent bg-[rgba(34,37,42,0.94)] px-3 text-system-white shadow-[0_4px_20px_rgba(0,0,0,0.24)] backdrop-blur-[30px] transition-colors hover:border-system-white12 hover:bg-[rgba(34,37,42,1)] data-[state=open]:border-system-white12 data-[state=open]:bg-[rgba(34,37,42,1)]"
      side="top"
    />
  );
};
